var vP7201 = require("./frvrSDK.js");
var vP72012 = require("three");
let vO158 = {};
function f1099(p7202) {
  const v6044 = vO158[p7202];
  if (v6044 !== undefined && v6044.length) {
    return v6044.pop();
  } else {
    return document.createElement("canvas");
  }
}
function f1100(p7203, p7204) {
  if (!vO158[p7204]) {
    vO158[p7204] = [];
  }
  vO158[p7204].push(p7203);
}
const config2 = require("../config.js");
const vF35 = () => {
  let v6045;
  let v6046;
  let v6047 = false;
  return {
    oncreate: p7205 => {
      function f1101() {
        if (v6053) {
          return;
        }
        if (!v6047) {
          return;
        }
        const v6048 = Date.now();
        let v6049 = v6048 - v6052;
        v6049 = Math.min(v6049, config2.dltMx);
        v6052 = v6048;
        p7205.attrs.render(v6049);
        requestAnimationFrame(f1101);
      }
      const v6050 = p7205.attrs.contextType || "2d";
      v6046 = f1099(v6050);
      const v6051 = p7205.dom.parentNode;
      p7205.dom.replaceWith(v6046);
      if (p7205.attrs.class) {
        v6046.className = p7205.attrs.class;
      }
      p7205.attrs.setup(v6046, v6051);
      v6045 = p7205.attrs.resize;
      if (v6045) {
        window.addEventListener("resize", v6045);
      }
      let v6052 = Date.now();
      let v6053 = false;
      v6047 = true;
      window.addEventListener("FRVRonSuspend", function () {
        v6053 = true;
      });
      window.addEventListener("FRVRonResume", function () {
        v6053 = false;
        f1101();
      });
      requestAnimationFrame(f1101);
    },
    onremove: p7206 => {
      if (v6045) {
        window.removeEventListener("resize", v6045);
      }
      v6047 = false;
      p7206.dom.replaceWith(document.createElement("div"));
      v6046.remove();
      v6046.className = "";
      v6046.style = null;
      const v6054 = p7206.attrs.contextType || "2d";
      f1100(v6046, v6054);
    },
    view: () => m("div.canvas-placeholder")
  };
};
var vVF35 = vF35;
var vP72014 = require("../data/itemTypes.js");
var v6055 = vP72014;
var config = require("../config.js");
var UTILS = require("../libs/utils.js");
var RENDER = new (require("../libs/render.js"))(null, null, true);
var v6057 = RENDER.THREE;
var v6058 = new (require("../libs/particles.js"))(RENDER);
const vF36 = p7207 => {
  function f1102() {
    v6072 = new v6057.Scene();
    v6072.name = "KR";
    v6072.add(new v6057.AmbientLight(5197647));
    var v6059 = new v6057.DirectionalLight(16777215, 3);
    v6059.position.set(1, 20, -3);
    v6072.add(v6059);
    v6073 = RENDER.genObj3D(0, 1, 0);
    v6073.rotateX(-Math.PI / 7);
    v6073.rotateY(0.57);
    v6073.rotateZ(-2.4499999999999997);
    v6073.orgXR = v6073.rotation.x;
    v6073.orgYP = v6073.position.y;
    let vLN2024 = 20.24;
    RENDER.loadMesh({
      src: "krunkie_0",
      texSrc: "krunkie_0",
      noGreen: true,
      uv2: true,
      fillScale: 60,
      centerZ: true
    }, 0, 0, 0, 0.3, vLN2024, v6073);
    v6072.add(v6073);
    v6076 = true;
    v6070.lookAt(v6072.position);
  }
  function f1103() {
    v6072 = new v6057.Scene();
    v6072.name = "Wheel";
    v6072.add(new v6057.AmbientLight(5197647));
    let v6060 = new v6057.DirectionalLight("#ffffff", 0.5);
    v6060.position.set(3, 1, 0);
    v6072.add(v6060);
    let v6061 = v6066.type ? v6066 : game.store.previews[v6066.weapon] || {};
    let v6062 = RENDER.genObj3D(0, 0, 0);
    v6073 = RENDER.genObj3D(0, 1 + (v6061.yOff || 0), v6061.xOff || 0);
    v6073.rotateX(v6066.type && v6066.type == v6055.DYE ? -Math.PI / 11 : -Math.PI / 7);
    v6073.rotateY(Math.PI + 0.5 + (v6061.zRota || 0));
    v6073.rotateZ(-0.5);
    v6073.orgXR = v6073.rotation.x;
    v6073.orgYP = v6073.position.y;
    if (v6066.type == v6055.TICKET && v6068) {
      v6061.scl = 3;
    }
    if (v6066.type && v6066.type == v6055.DYE) {
      let v6063 = new Player(-1, this, game);
      v6063.sid = -1;
      v6063.init(0.5, 0, -7, "preview", false);
      v6063.skins = [-1, -1];
      v6063.dyeIndex = parseInt(v6067);
      v6063.setClass(game, 9, 2, true);
      game.players.swapWeapon(v6063, 0, true);
      game.players.generateMeshes(v6063, false, true, true);
      v6073.add(v6063.objInstances);
      v6063.swapTime = 0;
      if (v6063 && v6063.weaponMeshes && v6063.weaponMeshes[0]) {
        v6063.weaponMeshes[0].visible = true;
      }
      if (v6063 && v6063.weaponGeos && v6063.weaponGeos[0]) {
        v6063.weaponGeos[0].visible = false;
      }
      game.players.updateMshClient(v6063, true);
    } else if (v6066.type && v6066.type == v6055.SPRAY) {
      let v6064 = new v6057.Mesh(new v6057.PlaneGeometry(1, 1));
      v6064.scale.set(9, 7.2, 1);
      v6064.material = RENDER.getMat("sprays/" + (v6066.id || 0), {
        local: v6066.local,
        depthWrite: false,
        transparent: true,
        frames: v6066.frames,
        frameT: v6066.frameT,
        centerZ: true
      });
      v6073.add(v6064);
      v6064.rotation.y = Math.PI * 1.1;
    } else {
      RENDER[v6066.hasAnim ? "loadAnimMesh" : "loadMesh"]({
        fileExt: v6066.fileExt,
        setLayer: 0,
        hasAnim: v6066.hasAnim,
        animS: v6066.animS,
        inspectAnim: v6066.inspectAnim,
        local: v6066.local,
        localM: v6066.localM,
        src: game.store.types[v6066.assetType || v6066.type || 0] + (v6066.assetType || v6066.type ? v6066.id : v6066.weapon) + (v6066.mid == null ? "" : "_" + v6066.mid),
        texSrc: v6066.mid == null ? v6066.type && v6066.type == v6055.MELEE ? v6066.pat ? v6066.tex : "melee/melee_" + (v6066.id || 0) + (v6066.tex ? "_" + v6066.tex : "") : v6066.type ? v6066.tex ? game.store.types[v6066.assetType || v6066.type || 0] + v6066.id + "_" + v6066.tex : null : v6066.tex ? v6066.tex : "weapons/skins/weapon_" + v6066.weapon + "_" + v6066.id : UTILS.getReModel(game.store, v6066),
        rotT: v6066.rotT,
        movT: v6066.movT,
        movD: v6066.movD,
        pulsT: v6066.pulsT,
        repeatY: v6066.tileS || 0,
        repeatX: v6066.tileS || 0,
        frames: v6066.frames,
        frameT: v6066.frameT,
        sameGlow: v6066.sameGlow,
        sameEnv: v6066.sameEnv,
        env: v6066.env || v6066.sameEnv ? v6066.env || 3 : undefined,
        glowText: v6066.glow || v6066.sameGlow,
        emissive: v6066.glow || v6066.sameGlow ? v6066.emiss || "#ffffff" : null,
        emissInt: v6066.glowInt,
        rgb: v6066.rgb,
        rgbS: v6066.rgbS,
        uv2: true,
        fillScale: 60,
        centerZ: true,
        color: v6066.color || null,
        rAnim: v6066.rAnim,
        rAnimA: v6066.rAnimA,
        rAnimT: v6066.rAnimT,
        rAnimM: v6066.rAnimM,
        transparent: v6066.opac != null || v6066.trans,
        useWireframe: v6066.wire,
        side: v6066.side || 0,
        opacity: v6066.opac || 1,
        alphaTest: v6066.alpha || 0,
        shaderNum: v6066.shaderNum,
        video: v6066.video,
        projection: v6066.projection
      }, 0, 0, 0, (v6066.type && v6066.type != v6055.MELEE ? Math.PI : Math.PI / 2) + (v6061.xRot || 0), (v6066.spnScl || v6061.scl || 1) * 2.2, v6073);
    }
    v6062.add(v6073);
    v6072.add(v6062);
    v6070.lookAt(v6072.position);
  }
  function f1104(p7208) {
    v6074 = p7208;
    const vIii9 = f1106();
    v6074.width = vIii9.width;
    v6074.height = vIii9.height;
    v6070 = new v6057.PerspectiveCamera(45, p7208.width / p7208.height, 0.1, 100);
    v6071 = new v6057.WebGLRenderer({
      precision: "mediump",
      antialias: false,
      alpha: true,
      canvas: p7208
    });
    v6071.setSize(vIii9.width, vIii9.height);
    v6071.setClearColor(0, 0);
    let vLN1101 = 1;
    v6071.setPixelRatio(window.devicePixelRatio * vLN1101);
    v6070.position.y = 10;
    if (v6066.kr) {
      f1102();
    } else {
      f1103();
    }
  }
  function f1105(p7209) {
    TWEEN.update();
    SOUND.rate = config.deltaMlt;
    if (v6070.position.x != v6075) {
      v6070.position.x -= (v6070.position.x - v6075) * 0.24;
      if (Math.abs(v6075 - v6070.position.x) <= 0.05) {
        v6070.position.x = v6075;
      }
      v6070.lookAt(v6072.position);
    }
    vLN0964 += p7209 * 0.0018;
    v6073.position.y = v6073.orgYP + Math.sin(vLN0964) * 0.55;
    v6073.rotation.x = v6073.orgXR + Math.sin(vLN0964 * 0.9) * -0.042;
    if (v6076) {
      v6073.rotation.y += 0.01;
    }
    v6071.render(v6072, v6070);
    if (v6058) {
      v6058.update(p7209 * config.deltaMlt, RENDER.fpsCamera.getWorldPosition(v6077));
    }
  }
  function f1106() {
    const v6065 = v6074.parentElement;
    const vGetComputedStyle = getComputedStyle(v6065);
    return {
      width: v6065.clientWidth - parseFloat(vGetComputedStyle.paddingRight) - parseFloat(vGetComputedStyle.paddingLeft),
      height: v6065.clientHeight - parseFloat(vGetComputedStyle.paddingTop) - parseFloat(vGetComputedStyle.paddingBottom)
    };
  }
  function f1107() {
    const vF1106 = f1106();
    v6071.setSize(vF1106.width, vF1106.height);
    v6070.aspect = vF1106.width / vF1106.height;
  }
  const v6066 = p7207.attrs.winItem;
  const v6067 = p7207.attrs.winItem.index;
  const v6068 = p7207.attrs.inPopup || false;
  const game = b().getGame();
  let v6070;
  let v6071;
  let v6072;
  let v6073;
  let v6074;
  let v6075 = p7207.attrs.distance || 40;
  let vLN0964 = 0;
  let v6076 = false;
  let v6077 = new vP72012.Vector3();
  return {
    view: p7210 => m(vVF35, {
      contextType: "webgl",
      class: p7210.attrs.fullscreen ? "canvas--fullscreen" : undefined,
      setup: f1104,
      render: f1105,
      resize: f1107
    })
  };
};
var vVF36 = vF36;
let v6078 = null;
let v6079 = null;
let v6080 = null;
export const c = (p7211, p7212, p7213) => {
  v6078 = p7211;
  v6079 = p7212;
  v6080 = p7213;
  const v6081 = document.getElementById("frvrMenuMobileHolder");
  // m.mount(v6081, vO160);
};
export const a = () => v6080;
export const b = () => v6079;
export const d = {
  canShowBookmark: false,
  isLoggedIn: false,
  isSpectatingOn: false,
  bpData: null,
  account: {
    premiumT: false,
    alias: "",
    name: "",
    level: -1,
    score: 0,
    funds: 0,
    wins: 0,
    games: 0,
    lastDoubleAttempt: 0
  },
  endScreenData: null,
  getCurrentView: function () {
    return Object(vP7201.getCurrentView)();
  },
  tournament: {
    id: ""
  },
  leaderboardData: null,
  endTimer: null,
  beforeGameLvl: 0,
  beforeGameBPLvl: 0
};
const vO160 = {
  view: function () {
    return Object(vP7201.buildViews)();
  }
};
const vF41 = () => showErrorPopup({
  message: a().i18n.t("window.watchAds.popup.no")
});
const vF42 = () => showErrorPopup({
  message: a().i18n.t("window.watchAds.popup.interrupted")
});
function f1108(p7214) {
  Object.keys(p7214).forEach(p7215 => {
    d[p7215] = p7214[p7215];
  });
  m.redraw();
}